import { Box, Typography } from "@mui/material"
import { Comparison } from "routes/schedule/compare/lib/diff3"

export function PreviewText({ value, dataCy, originalValue, comparisonValue, showRemoved = false }) {
    if (!hasVisibleContent(value)) {
        return (
            <Typography variant="body2" color="text.disabled" data-cy={dataCy}>
                (empty)
            </Typography>
        )
    }

    return (
        <Box
            sx={{
                fontSize: 12,
                lineHeight: 1.5,
                color: "text.secondary",
                wordBreak: "break-word",
                "& p": {
                    fontSize: "inherit",
                    lineHeight: "inherit",
                    color: "inherit",
                },
            }}
            data-cy={dataCy}
        >
            <Comparison text={value} original={originalValue} other={comparisonValue} showRemoved={showRemoved} />
        </Box>
    )
}

function hasVisibleContent(value) {
    return `${value ?? ""}`.replace(/<[^>]*>/g, "").trim().length > 0
}
